// extracted by mini-css-extract-plugin
module.exports = {"supportedBySection":"partners_supportedBySection__OHEAz","logosContainer":"partners_logosContainer__1A-JC","logoItem":"partners_logoItem__3aYD6"};